export enum DonationFormPageHeaderKey {
  SHAREABLE_LINK = 'shareable_link',
  EMBEDDED_SNIPPET = 'embedded_snippet'
}

export type DonationFormPageHeaderProps = {
  activeTab: DonationFormPageHeaderKey
  setActiveTab: (tab: DonationFormPageHeaderKey) => void
}
